import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  login: boolean = true;
  title = 'Reporting Server';

  constructor(private router: Router) {
    
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/login') || event.urlAfterRedirects.startsWith('/login') || event.url === '/forgotPassword' || event.urlAfterRedirects === '/forgotPassword') {
          this.login = true;
        } else {
          this.login = false;
        }
      }
    });

  }
    ngOnInit(): void {
        
    }

}
